import { ATP_CLUSTER_ID, CUSTOMER_TYPE_ID, getHeaders as getHeadersUtility, USE_PRODUCT_DATA_CACHING, USE_PRODUCTS_SERVICE, VISITOR_SEGMENT } from '@ori/fetching';
/**
 * Utility function for generating core, user segmentation and products headers for HTTP requests. Returns object with headers.
 * @example
 *
 * const headers = getHeaders({
 *       sourceAppName: 'app',
 *       language: 'cs',
 *       customerId: 1,
 *       tenant: 'cz',
 *       token: 'some-token',
 *     }),
 *
 * useGraphqlQuery({query, url, headers: headers})
 */
export const getHeaders = ({
  atpClusterId,
  customerId,
  customerTypeId,
  language,
  sourceAppName,
  tenant,
  token,
  useProductDataCaching = true,
  useProductsService = true,
  visitorSegment
}) => {
  const headers = getHeadersUtility({
    customerId,
    language,
    sourceAppName,
    tenant,
    token
  });
  if (atpClusterId != null) {
    headers[ATP_CLUSTER_ID] = atpClusterId;
  }
  if (visitorSegment != null) {
    headers[VISITOR_SEGMENT] = visitorSegment;
  }
  headers[CUSTOMER_TYPE_ID] = customerTypeId ?? 0;
  headers[USE_PRODUCTS_SERVICE] = useProductsService;
  headers[USE_PRODUCT_DATA_CACHING] = useProductDataCaching;
  return headers;
};
//# sourceMappingURL=getHeaders.js.map